$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

function handleCheckboxRadios(container = $('body')) {
  container.find('#sylius-product-variants input[type=radio]').each(function () {
    $(this).parent().addClass('radio-container');
    $(this).after('<label for="' + $(this).attr('id') + '"></label>');
  });
  container.find('.check-container, .radio-container').each(function () {
    if ($(this).find('label span.inc').length === 0 && !$(this).find('label').hasClass('switch')) {
      $(this).find('label').append('<span class="inc"></span><span class="check"></span><span class="check-border"></span>');
    }
  });
  container.addClass('native-radio-check-hidden');
  // Material design ckeckbox and radio effects
  container.find('.check-container > label').on('click', function () {
    if (!$(this).hasClass('switch')) {
      var the = $(this);
      // find the first span which is our circle/bubble
      var el = $(this).children('span:first-of-type');

      // add the bubble class (we do this so it doesnt show on page load)
      el.addClass('inc');

      // clone it
      var newOne = el.clone(true);

      // add the cloned version before our original
      el.before(newOne);

      // remove the original so that it is ready to run on next click
      $('.' + el.attr('class') + ':last', the).remove();
    }
  });
}

// auto cart refresh
var cartChanged = function () {
  var qtyChanged = false;
  var invoiceChanged = false;
  var productsChanged = false;
  $('form[name=sylius_cart] .iso-df-spinner input').each(function () {
    if ($(this).attr('new_value') && ($(this).attr('value') !== $(this).attr('new_value'))) {
      qtyChanged = true;
    }
  });
  if ($('.one-check-only').attr('new_value') && ($('.one-check-only').attr('value') !== $('.one-check-only').attr('new_value'))) {
    invoiceChanged = true;
  }
  return qtyChanged || invoiceChanged;
};

var cartUpdateTimeout;

var setCartUpdate = function () {
  if ($('#sylius-cart-update').length) {
    clearTimeout(cartUpdateTimeout);
    $('.iso-df-btn-cart-reload').addClass('reload-single');
    $('.iso-df-btn-cart-goto-checkout').addClass('blocked');
    cartUpdateTimeout = setTimeout(function () {
      if (cartChanged()) {
        $('#sylius-cart-update').trigger('click');
      } else {
        $('.iso-df-btn-cart-reload').removeClass('reload-single');
        $('.iso-df-btn-cart-goto-checkout').removeClass('blocked');
      }
    }, 1500);
  }
}; // END auto cart refresh

$('.iso-df-spinner input').on('focus', function () {
  $(this).select();
});

var isoDfLayoutQtySpinner = function () {
  return {
    // main function to initiate the module
    init: function () {
      $('body').on('click', '.iso-df-spinner-btn-up', function () {
        var $elem = $(this).parents('.iso-df-spinner');
        var dataInput = $(this).attr('data_input');
        var QTY = $elem.find('input.' + dataInput);
        var dataMax = ($(this).data('maximum')) ? $(this).data('maximum') : 999;
        if (QTY.val() < dataMax) {
          QTY.val(parseInt(QTY.val(), 10) + 1);
          QTY.attr('new_value', QTY.val());
          setCartUpdate();
        } else {
          QTY.attr('new_value', QTY.val());
        }
      }).on('click', '.iso-df-spinner-btn-down', function () {
        var $elem = $(this).parents('.iso-df-spinner');
        var dataInput = $(this).attr('data_input');
        var QTY = $elem.find('input.' + dataInput);
        if (QTY.val() != 1) {
          QTY.val(parseInt(QTY.val(), 10) - 1);
          QTY.attr('new_value', QTY.val());
          setCartUpdate();
        } else {
          QTY.attr('new_value', QTY.val());
        }
      }).on('input', '.iso-df-spinner input', function () {
        var QTY = $(this);
        if ((parseInt(QTY.val(), 10) < 1) || isNaN(parseInt(QTY.val(), 10))) {
          QTY.val(1);
        }
        QTY.attr('new_value', QTY.val());
        setCartUpdate();
      }).on('blur', '.iso-df-spinner input', function () {
        var QTY = $(this);
        if ((parseInt(QTY.val(), 10) < 1) || isNaN(parseInt(QTY.val(), 10))) {
          QTY.val(1);
        }
        QTY.attr('new_value', QTY.val());
        setCartUpdate();
      });
    }
  };
}();

var isoDfLayoutCheckboxVisibilityToggle = function () {
  return {
    // main function to initiate the module
    init: function () {
      $('.iso-df-toggle-hide').each(function () {
        var $checkbox = $(this).find('input[type=checkbox]'),
          $speed = $(this).data('animation-speed'),
          $object = $('.' + $(this).data('object-selector'));

        $object.hide();

        if (typeof $speed === 'undefined') {
          $speed = 'slow';
        }

        $($checkbox).on('change', function () {
          if ($($object).is(':hidden')) {
            $($object).show($speed);
          } else {
            $($object).slideUp($speed);
          }
        });

        if ($checkbox.attr('checked')) {
          $($object).show();
        }
      });
    }
  };
}();

function initQuickviewGallery(container = $('.product-modal')) {
  // Quickview Lightbox
  var hasQvPopup = container.find('a').hasClass('open-gallery');

  if (hasQvPopup) {
    container.find('.open-gallery').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      }
    });
  }
} // initGallery

function buildAlert(message, alertType = 'success', dismissible) {
  var closeButton = '';
  if (dismissible) {
    closeButton = '<button type="button" class="close" data-dismiss="alert" aria-label="' + isoDfTranslations.close + '"><span aria-hidden="true">&times;</span></button>';
  }
  var alertHTML = '<div class="alert alert-' + alertType + '" role="alert">' + message + closeButton + '</div>';

  return alertHTML;
}

function copyLinkToClipboard() {
  $('#isoshop-shared-cart input').select();

  try {
    var successful = document.execCommand('copy');
    if (successful) {
      $('#isoshop-shared-cart').prepend(buildAlert(isoDfTranslations.link_has_been_copied, 'success', true));
    } else {
      $('#isoshop-shared-cart').prepend(buildAlert(isoDfTranslations.link_copying_failed, 'danger', true));
    }
  } catch (err) {
    $('#isoshop-shared-cart').prepend(buildAlert(isoDfTranslations.link_copying_failed, 'danger', true));
  }

  $('#isoshop-shared-cart input').blur();
  $('#isoshop-shared-cart a').blur();
}

(function ($) {
  'use strict';

  $.fn.extend({
    saveCart: function () {
      var element = $(this);
      var csrfToken = $(element).data('csrf-token');
      var dataUrl = $(element).data('url');

      $(this).on('click', function (e) {
        var listName = $('#isoshop-save-cart-list-name').val();

        if (listName) {
          $.ajax({
            method: 'POST',
            url: dataUrl,
            cache: false,
            data: { _csrf_token: csrfToken, name: listName },
            success: function (response) {
              element.parent('#sylius-saved-cart').prepend(buildAlert(isoDfTranslations.cart_saved, 'success', true));
            },
            error: function (response) {
              element.parent('#sylius-saved-cart').prepend(buildAlert(isoDfTranslations.unknown_error, 'danger', true));
            }
          });
        } else {
          element.parent('#sylius-saved-cart').prepend(buildAlert(isoDfTranslations.provide_list_name, 'warning', true));
        }

        e.preventDefault();
      });
    },
    shareCart: function () {
      var element = $(this);
      var csrfToken = $(element).data('csrf-token');
      var dataUrl = $(element).data('url');

      $(this).on('click', function (e) {
        $(this).attr('disabled', 'disabled');

        $.ajax({
          method: 'POST',
          url: dataUrl,
          cache: false,
          data: { _csrf_token: csrfToken },
          success: function (response) {
            // console.log(response);
            $('#isoshop-shared-cart').html('<input class="form-control"><button class="btn iso-df-btn-copy-link">' + isoDfTranslations.copy_link + '</button>');
            $('#isoshop-shared-cart input').val(response.url);
            $('#isoshop-shared-cart button').on('click', function (e) {
              e.preventDefault();
              copyLinkToClipboard();
            });
          },
          error: function (response) {
            alert('Error');
          }
        });

        e.preventDefault();
      });
    }
  });
})(jQuery);

//Swiss - search
function posEnd(el) {
  var len = el.value.length;
  var t = el.createTextRange;

  if (el.setSelectionRange) {
    el.focus();
    el.setSelectionRange(len, len);
  } else if (el.createTextRange) {
    t.collapse(true);
    t.moveEnd('character', len);
    t.moveStart('character', len);
    t.select();
  }
}

var searchResultsToBoxFocus = false;

$(document).on('keydown', 'form.hm-searchbox', function (event) {
  return event.key !== 'Enter';
});

function swisssoftSearchInit() {
  $('#swisssoft-search').on('keyup focusin', function (e) {
    if (e.type === 'keyup' && searchResultsToBoxFocus) {
      posEnd(this);
      $(this).removeClass('caret-trans');
      searchResultsToBoxFocus = false;
    }
    if ([37, 38, 39, 40].indexOf(e.which) < 0) {
      var textLength = $(this).val().length;
      if ($('#navbar').hasClass('in')) {
        $('.navbar-toggle').trigger('click');
      }
      if (textLength >= 2) {
        $('#swisssoft-autocomplete-results').addClass('loading');
        var filteredQuery = $(this).val().replace('&', '');
        $.get('/swisssoft/shop-search.html', { query: filteredQuery })
          .done(function (data) {
            clearTimeout(navTimer);
            $('#swisssoft-autocomplete-results').html(data).removeClass('loading');
            $('.navbar').addClass('expanded');
            $('.result-item').each(function () {
              $(this).on('mouseover', function () {
                $('.result-item.focused').removeClass('focused');
                $(this).addClass('focused')
                  .focus();
              }).on('mouseleave', function () {
                $(this).removeClass('focused')
                  .blur();
              });
            });
            $('.autocomplete-menu').addClass('active')
              .on('keydown', function (k) {
                var focused = $('.result-item.focused');
                switch (k.which) {
                  case 13:
                    window.location.href = focused.find('a').attr('href');
                    break;
                  case 38:
                    if (focused.prev().length) {
                      focused.removeClass('focused').prev()
                        .addClass('focused')
                        .focus();
                    } else if (!(window.innerWidth > 767) && focused.closest('div').prev().length) {
                      focused.removeClass('focused').closest('div').prev().find('.result-item')
                        .last()
                        .addClass('focused')
                        .focus();
                    } else {
                      searchResultsToBoxFocus = true;
                      $('#swisssoft-search').addClass('caret-trans').focus();
                    }
                    break;
                  case 40:
                    if (focused.next().length) {
                      focused.removeClass('focused').next()
                        .addClass('focused')
                        .focus();
                    } else if (!(window.innerWidth > 767) && focused.closest('div').next().length) {
                      focused.removeClass('focused').closest('div').next().find('.result-item')
                        .first()
                        .addClass('focused')
                        .focus();
                    }
                    break;
                  case 37:
                    if (window.innerWidth > 767) {
                      if ($('.cat-part').length) {
                        focused.removeClass('focused');
                        $('.cat-part .result-item').first().focus()
                          .addClass('focused');
                      }
                    }
                    break;
                  case 39:
                    if (window.innerWidth > 767) {
                      if ($('.prod-part').length) {
                        focused.removeClass('focused');
                        $('.prod-part .result-item').first().focus()
                          .addClass('focused');
                      }
                    }
                    break;
                  default:
                }
              });
          });
      } else if ($('.autocomplete-menu').hasClass('active')) {
        $('.navbar').removeClass('expanded');
        $('.autocomplete-menu').removeClass('active');
      }
    } else if (e.which === 40 && !$('#swisssoft-autocomplete-results').hasClass('loading')) {
      if ($('#swisssoft-autocomplete-results .prod-part').length) {
        $('.prod-part li').first().addClass('focused').focus();
      } else if ($('#swisssoft-autocomplete-results .cat-part').length) {
        $('.cat-part li').first().addClass('focused').focus();
      }
    }
  });
  $('body').on('click', function (e) {
    if (!$(e.target).closest('.autocomplete-menu').length && $('.autocomplete-menu').hasClass('active')) {
      $('.navbar').removeClass('expanded');
      $('.autocomplete-menu').removeClass('active');
    }
  });
}

(function ($) {
  $.fn.extend({
    autocompleteSearch: function (autocompleteInputElement, apiEndpointPath) {
      $(autocompleteInputElement)
        .search({
          type: 'category',
          minCharacters: 3,
          debug: true,
          verbose: true,
          apiSettings: {
            onResponse: function (autocompleteResponse) {
              var response = { results: {} };

              $.each(autocompleteResponse.items, function (index, item) {
                var taxonName = item.taxon_name;
                var maxResults = 15;

                if (index >= maxResults) {
                  return false;
                }

                if (response.results[taxonName] === undefined) {
                  response.results[taxonName] = {
                    name: taxonName,
                    results: []
                  };
                }

                response.results[taxonName].results.push({
                  title: item.name,
                  description: item.description,
                  url: item.slug,
                  price: item.price,
                  image: item.image
                });
              });

              return response;
            },
            url: apiEndpointPath
          }
        })
      ;
    }
  });
})(jQuery);

function initVariantsTable(container) {
  if (container === undefined) container = $('body');
  var linkMore = container.find('.btn-more-variants');
  var linkLess = container.find('.btn-less-variants');
  var variantClass = '.variant-wrapper';

  linkMore.each(function () {
    $(this).on('click', function () {
      var variantTable = $(this).parents(variantClass);
      variantTable.addClass('open');
    });
  });
  linkLess.each(function () {
    $(this).on('click', function () {
      var variantTable = $(this).parents(variantClass);
      variantTable.removeClass('open');
    });
  });

  if (container.find('[name="sylius_add_to_cart[cartItem][variant]"]:checked').is(':disabled')) {
    if (container.find('[name="sylius_add_to_cart[cartItem][variant]"]:enabled').length > 0) {
      container.find('[name="sylius_add_to_cart[cartItem][variant]"]:enabled').first().trigger('click');
    } else if (container.find('.variant-wrapper').length > 0) {
      container.find('[name="sylius_add_to_cart[cartItem][variant]"]').prop('checked', false);
      container.find('.iso-df-spinner').parent().nextAll().remove();
      container.find('.iso-df-spinner').parent().remove();
      container.find('.prod-price').remove();
    }
  }

  var checkedVariant = container.find('[name="sylius_add_to_cart[cartItem][variant]"]:checked');
  checkedVariant.trigger('change');
  if (checkedVariant.parents('tr').index() > 3) {
    linkMore.trigger('click');
  }
}

function isTouchEnabled() {
  return ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0);
}

function productBoxesTouchEvents(container = $('body')) {
  container.find('.shop-product-card-inner').on({
    touchstart() {
      if (!$(this).parent().hasClass('hovered')) {
        container.find('.shop-product-card').removeClass('hovered');
      }
    },
    touchend(e) {
      if (!$(this).parent().hasClass('moving')) {
        if (!$(this).parent().hasClass('hovered')) {
          e.preventDefault();
          container.find('.shop-product-card').removeClass('hovered');
          $(this).parent().addClass('hovered');
        }
      } else {
        $(this).parent().removeClass('moving');
      }
    },
    touchmove() {
      $(this).parent().addClass('moving');
    },
  });
}

function productModalInitAndShow(event, element, options) {
  const {
    variantCode = element.data('variant-code'),
    ajaxURL = element.data('ajax-url'),
    removeUrl,
    csrfToken,
  } = options;

  $.get(ajaxURL, options, (modalHTML) => {
    $('#product-modal').modal('hide').data('bs.modal', null).remove();
    $('.modal.in').modal('hide');
    $('.modals').append(modalHTML);

    const productModal = $('#product-modal');

    productModal.find('.modal-dialog').on('click', function (e) {
      if (e.currentTarget === e.target) {
        productModal.trigger('click');
      }
    });

    if (options.modalType === 'productAdded') {
      if (isTouchEnabled()) {
        productBoxesTouchEvents($('.modal-associations'));
      }
      productModal.find('.buy-btn').on('click', function (e) {
        productModalInitAndShow(e, $(this), { modalType: 'quickView' });
      });
    }

    if (productModal.find('#sylius-variants-pricing').length > 0) {
      handleProductOptionsChange();
    } else if (productModal.find('#sylius-product-variants').length > 0) {
      handleCheckboxRadios(productModal);

      productModal.find('.radio-container').find('label').each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();
          $(this).siblings('input').trigger('click');
        });
      });

      handleProductVariantsChange(options.quantity);
      productModal.find('[name="sylius_add_to_cart[cartItem][variant]"]:enabled').first().trigger('click');
    }

    productModal.find('#sylius-product-adding-to-cart').addToCart();

    productModal.on('shown.bs.modal', function () {
      clearTimeout(window.cartRefreshTimeout);
      if (options.modalType === 'productAdded') IsoshopConfig.cartRefreshRequired = true;
      if (variantCode !== undefined) $(this).find(`input[value="${variantCode}"]`).trigger('click');
      if (options.modalType === 'quickView') initVariantsTable(productModal);
      if (options.modalType === 'productAdded' || options.modalType === 'removeProduct') {
        productModal.find('.iso-df-product-add-cart').remove();
      }
      if (options.modalType === 'removeProduct') {
        productModal.find('.product-modal-confirm').on('click', (e) => {
          $.ajax({
            url: removeUrl,
            method: 'POST',
            data: { _csrf_token: csrfToken, _method: 'DELETE' },
            success() {
              if (window.location.href.indexOf(IsoshopConfig.cartUrl) > -1) {
                window.location.href = IsoshopConfig.cartUrl;
              } else if (window.location.href.indexOf(IsoshopConfig.checkoutUrl) > -1) {
                window.location.href = IsoshopConfig.checkoutUrl;
              } else if (window.location.href.indexOf(IsoshopConfig.completeUrl) > -1) {
                window.location.href = IsoshopConfig.completeUrl;
              } else {
                cartWidgetRefresh();
                productModal.modal('hide').data('bs.modal', null).remove();
              }
            },
          });
          e.preventDefault();
        });
      }
      setTimeout(function () {
        initQuickviewGallery(productModal);
      }, 500);
    }).on('hide.bs.modal', function () {
      if (IsoshopConfig.cartRefreshRequired === true) {
        setCartRefresh();
      }
    }).on('hidden.bs.modal', function () {
      $(this).data('bs.modal', null).remove();
    });

    productModal.modal('show');
  });
  if (event !== null) event.preventDefault();
}

function cartWidgetRefresh() {
  let cartWidget = $('.cart-nav');
  $.ajax({
    method: 'GET',
    url: cartWidget.data('cart-widget-url'),
    cache: false,
    success(response) {
      cartWidget.replaceWith(response);
      cartWidget = $('.cart-nav');
      cartWidget.find('.sylius-cart-remove-button').removeFromCart();
      cartWidget.find('.dropdown-toggle').dropdownHover();
      cartWidget.find('.cart-notif').addClass('refresh-pulse');
      $('.clear-all-products-modal-toggler').on('click', function (e) {
        if (e.originalEvent !== undefined) {
          e.preventDefault();
        }
      });
    },
  });
}

$(document).ready(function () {
  $(document).variantPrices();
  $(document).provinceField();

  initVariantsTable($('.product-info'));

  // Swiss - boxes on mobile, requires HTML update on SoftMedia
  // if (isTouchEnabled()) {
  //   productBoxesTouchEvents($('.section-shop'));
  //   productBoxesTouchEvents($('.iso-df-section-products'));
  //
  //   $('body').on('touchstart', function (e) {
  //     if (!$(e.target).closest('.shop-product-card-inner').length) {
  //       $('.shop-product-card').removeClass('hovered');
  //     }
  //   });
  // }

  $('#isoshop-save-cart').saveCart();
  $('#isoshop-share-cart').shareCart();

  isoDfLayoutQtySpinner.init();
  isoDfLayoutCheckboxVisibilityToggle.init();

  //Swiss - search, not implemented in SoftMedia
  swisssoftSearchInit();

  $('#search-toggle').on('click', function () {
    if ($('#navbar').hasClass('in')) {
      $('.navbar-toggle').trigger('click');
    }
    if ($('.search-box').hasClass('inside')) {
      $('.search-box').removeClass('inside');
    } else {
      $('.search-box').addClass('inside');
      // $('#swisssoft-search').focus();
    }
  });

  $('.search-btn.dummy-btn').on('click', function () {
    $('#swisssoft-search').focus();
  });

  $('.navbar-toggle').on('click', function () {
    $('.search-box').removeClass('inside');
    $('.navbar').removeClass('expanded');
    $('.autocomplete-menu').removeClass('active');
  });

  $('.nav-bg-overlay').on('click', function () {
    if ($('#navbar').hasClass('in')) {
      $('.navbar-toggle').trigger('click');
    } else {
      $('.navbar').removeClass('expanded');
    }
  });

  handleCheckboxRadios();

  // Swiss - invoice selection checkboxes, not needed in SoftMedia
  // var isChecked = false;
  //
  // $('.one-check-only input').each(function () {
  //   if ($(this).attr('checked') === 'checked') {
  //     isChecked = true;
  //     $(this).parents('.one-check-only').attr('value', $(this).attr('id'));
  //     $(this).parents('.check-container').siblings('.check-container').find('input')
  //       .removeAttr('checked')
  //       .prop('checked', false);
  //   }
  // }).on('change', function (e) {
  //   if ($(this).attr('checked') !== 'checked') {
  //     $(this).attr('checked', 'checked').prop('checked', true);
  //     $(this).parents('.one-check-only').attr('new_value', $(this).attr('id'));
  //     $(this).parents('.check-container').siblings('.check-container').find('input')
  //       .removeAttr('checked')
  //       .prop('checked', false);
  //     setCartUpdate();
  //   } else {
  //     $(this).attr('checked', 'checked').prop('checked', true);
  //   }
  //   e.preventDefault();
  // });
  //
  // if (!isChecked) {
  //   $('.one-check-only input').first().attr('checked', 'checked').prop('checked', true);
  //   $('.one-check-only').attr('value', $('.one-check-only input').first().attr('id'));
  // }

  // not sure if it's necessary
  if (!$('.iso-df-shipping-calculator input[type=radio]:checked').length) {
    $('.iso-df-shipping-calculator input[type=radio]').first().attr('checked', 'checked').prop('checked', true);
  }

  $('.address-book-select li').on('click', function () {
    var addressSelected = $(this);
    var element = addressSelected.parents('.a-form');
    var inputs = element.find('input');

    $.each(inputs, function (key, input) {
      $(input).val('');
    });

    var parseKey = function (key) {
      return key.replace(/(_\w)/g, function (m) { return m[1].toUpperCase(); });
    };
    $.each(addressSelected.data(), function (key, property) {
      if (key === 'countryCode') {
        element.find('select[name*=' + parseKey(key) + ']').val(property);
      } else if (key === 'isoshopVatIdNumber') {
        element.find('input[name*=isoshopVATIdNumber]').val(property);
      } else {
        element.find('input[name*='+ parseKey(key) +']').val(property);
      }
    });
  });

  // quickview modal open
  $('.shop-product-card .buy-btn, .saved-cart-link, .cart-item-link').on('click', function (e) {
    productModalInitAndShow(e, $(this), { modalType: 'quickView' });
  });

  $('.widget-item button').on('click', function (e) {
    e.preventDefault();
  });

  $('.slick-dots li a').on('click', function (e) {
    e.preventDefault();
  });

  // SoftMedia - hover product box on touch screen
   $('.shop-product-card .shop-p-slider a').on('click', function (e) {
    if ("ontouchstart" in document.documentElement) {
      if (!$(this).hasClass('hovered')) {
        $(this).addClass('hovered');
        e.preventDefault();
      }
    }
  }).on('mouseleave', function () {
    $(this).removeClass('hovered');
  });

  // element position
  $('.forget-pass-link').parent('span').insertAfter($('#_password').siblings('label').first());

  // checkout total price calculate
  $('.iso-df-shipping-calculator input[type="radio"]').on('click change', function () {
    $('#iso_order_total').html($(this).siblings('.extra').data('order-total'));
  });

  $('.checkout-complete-trigger').on('click', function (e) {
    e.preventDefault();
    $('.iso-df-btn-goto-complete').trigger('click');
  });

  // scroll to first form error if not in viewport
  if ($('.iso-df-validation-error').length) {
    if (!$('.iso-df-validation-error').isInViewport()) {
      $('html, body').animate({
        scrollTop: $('.iso-df-validation-error').first().offset().top - 60
      }, 1000);
    }
  }

  // user account current page highlighted in menu
  $('.iso-df-page-account .shop-sidebar-vertical ul li a').each(function () {
    var currentURL =  window.location.href;
    if (currentURL.indexOf($(this).attr('href')) != -1) {
      $(this).parent().addClass('active');
    }
  });

  // no-touch screens top level menu items clickable
  $('html.no-touch #navbar .nav li.dropdown > a').on('click', function () {
    if ($(this).attr('href') != '#') window.location.href = $(this).attr('href');
  });

  $('form[name=sylius_cart] .iso-df-btn-cart-goto-checkout, .iso-df-page-cart .goto-checkout-address').on('click', function (e) {
    if (cartChanged()) {
      $('#sylius-cart-update').trigger('click');
    }
  });

  $('#iso-df-products-sorting').on('change', function () {
    window.location.href = $(this).find('option:selected').attr('data-href');
  });

  $('#iso-df-products-sorting option').each(function () {
    var currentURL =  window.location.href;
    if (currentURL.indexOf($(this).attr('data-href')) != -1) {
      $(this).attr('selected', true);
    }
  });

  // Swiss - search
  // $(window).on('keydown', function (e) {
  //   if (([32, 37, 38, 39, 40].indexOf(e.which) > -1) && $('.autocomplete-menu').hasClass('active') && (!$('#swisssoft-search').is(':focus'))) {
  //     e.preventDefault();
  //   }
  // });
});
